module.exports = __webpack_public_path__ + "22086396ee548c5b5a341522cc61c68e.png";